module.exports = {
  title: `Junbyeol Blog`,
  description: `소프트웨어 엔지니어 윤준성의 기술블로그`,
  author: `Junsung Yoon`,
  introduction: `Software Enginner focusing on Node.js`,
  siteUrl: `https://junbyeol.github.io`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `junbyeol`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: `준성-윤-84bbb2209`, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/junbyeol-fabicon.png`, // Add your favicon
  keywords: [`blog`, `junbyeol`, `techblog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'junbyeol/junbyeol.github.io', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'junbyeol',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-256408111-1', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`

}
